import React, { useRef } from "react";
import { Modal } from "../../../../../../shared/modals/Modal";
import {
  AuthButtonWrapper,
  AuthRedirectHeader,
  AuthRedirectInfo,
  AuthRedirectWrapper,
  InfoIconWrapper,
} from "./styles";
import Info from "../../../icons/Info";
import { useTranslation } from "react-i18next";
import Button from "../../../../../../shared/button/button";
import useOutsideClick from "../../../../../../hooks/useOnClickOutside";

function AuthRedirect({ isOpen = false, onToggle }) {
  const { t } = useTranslation();

  function handleAuthClick() {
    window.open(
      "https://online.procreditbank.ge/",

      "noopener,noreferrer"
    );
    onToggle();
  }

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={onToggle}>
        <AuthRedirectWrapper>
          <InfoIconWrapper>
            <Info />
          </InfoIconWrapper>
          <AuthRedirectHeader>
            {t("already_have_account_header")}
          </AuthRedirectHeader>
          <AuthRedirectInfo>{t("already_have_account_info")}</AuthRedirectInfo>
          <AuthButtonWrapper>
            <Button onClick={handleAuthClick} width={"100%"}>
              {t("authorization")}
            </Button>
          </AuthButtonWrapper>
        </AuthRedirectWrapper>
      </Modal>
    </React.Fragment>
  );
}

export default AuthRedirect;
